import React, { useEffect, useState } from "react";
import { getAccessToken } from "../../storage/storage";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { IoMdArrowBack } from "react-icons/io";
import { OtherTaskSheetSkeleton } from "../../components/Skeletons";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import TaskSheetDetail from "./components/TaskSheetDetail";
import { FormatDate } from "../../utils/FormateDate";
import { getApiErrorMessage } from "../../utils/apiError";

const OtherTaskSheets = () => {
  const token = getAccessToken();
  const { id } = useParams();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [invoiceData, setInvoiceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [invoice, setInvoice] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/task-sheets/property/${id}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setInvoiceData(response.data);
        setError("");
        setLoading(false);
      } catch (err) {
        console.error("Error fetching invoice:", err);
        setInvoiceData([]);
        setError(getApiErrorMessage(err, "Failed to load task sheets."));
      } finally {
        setLoading(false);
      }
    };

    fetchInvoice();
  }, [id]);

  return (
    <>
      {show === false ? (
        <div className="flex lg:flex-row flex-col lg:items-start items-center px-6 w-full h-[100vh]">
          <div className="flex lg:flex-row flex-col lg:items-start items-center px-6 w-full h-full">
            <div className="lg:px-10 px-4 mt-8 mb-16 h-[100vh] w-full">
              <Link
                to="/other-tasks"
                className="flex items-center gap-2 text-xl font-bold text-[#586989] hover:text-blue-600"
              >
                <IoMdArrowBack />
                <p>Back</p>
              </Link>
              <div className="relative mt-4 pb-5">
                <div className="border border-[#DFDFDF] bg-white rounded-lg shadow-md overflow-auto max-h-[70vh] w-full">
                  {/* <table className="w-full border-collapse min-w-[600px]">
                <thead className="sticky top-0 bg-[#FFF5CE] text-[#586989] z-10">
                  <tr>
                    <th className="border border-gray-300 px-4 py-4">
                      Invoice ID
                    </th>
                    <th className="border border-gray-300 px-4 py-2">
                      Property Name
                    </th>
                    <th className="border border-gray-300 px-4 py-2">
                      Cleaner
                    </th>
                    <th className="border border-gray-300 px-4 py-2">
                      Task Name
                    </th>
                    <th className="border border-gray-300 px-4 py-2">Rate</th>
                    <th className="border border-gray-300 px-4 py-2">
                      Quantity
                    </th>
                    <th className="border border-gray-300 px-4 py-2">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <>
                      <TableSkelton3 />
                    </>
                  ) : invoiceData.length === 0 ? (
                    <tr>
                      <td
                        colSpan="7"
                        className="text-center py-5 text-gray-500"
                      >
                        No Task Sheet Found
                      </td>
                    </tr>
                  ) : (
                    invoiceData.map((invoice) =>
                      invoice.tasks.map((task, index) => (
                        <tr
                          key={`${invoice.invoice_id}-${index}`}
                          className="border"
                        >
                          <td className="border border-gray-300 px-4 py-5">
                            {invoice.invoice_id}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            {invoice.property.name}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            {invoice.cleaner.name}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            {task.task_name}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            ${task.rate}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            {task.quantity}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            ${task.total}
                          </td>
                        </tr>
                      ))
                    )
                  )}
                </tbody>
              </table> */}
                  <table className="w-full border-collapse min-w-[600px]">
                    <thead className="sticky top-0 bg-[#FFF5CE] text-[#586989] z-10">
                      <tr>
                        <th className=" border-gray-300 px-4 py-4">
                          Clean Date{" "}
                        </th>
                        <th className=" border-gray-300 px-4 py-2">
                          Property Name
                        </th>
                        <th className=" border-gray-300 px-4 py-2">
                          Cleaner Name
                        </th>
                        <th className=" border-gray-300 px-4 py-2">Address </th>

                        <th className=" px-4 py-2">View Task Sheets</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <>
                          <OtherTaskSheetSkeleton />
                        </>
                      ) : invoiceData.length === 0 ? (
                        <tr>
                          <td
                            colSpan="7"
                            className={`text-center py-5 ${error ? "text-[#DC2626]" : "text-gray-500"}`}
                          >
                            {error || "No Task Sheet Found"}
                          </td>
                        </tr>
                      ) : (
                        invoiceData?.map((task, index) => (
                          <tr key={index} className="border">
                            {/* <td className="border border-gray-300 px-4 py-5 text-center">
                              {task?.property?.date || task?.date}
                            </td> */}
                            <td className="border border-gray-300 px-4 py-5 text-center">
                              {task?.tasks[0]?.date ||"-"}
                            </td>
                            <td className="border border-gray-300 px-4 py-6 text-center">
                              {task?.property?.name || "-"}
                            </td>
                            <td className="border border-gray-300 px-4 py-2 text-center">
                              {task?.cleaner?.name || "-"}
                            </td>
                            <td className="border border-gray-300 px-4 py-2 text-center">
                              {task?.property?.address || "-"}
                            </td>

                            <td className="border border-gray-300 px-4 py-2">
                              <div
                                onClick={() => {
                                  if (invoiceData && invoiceData.length > 0) {
                                    setInvoice(task);
                                    setShow(true);
                                  }
                                }}
                                className="text-center flex justify-center items-center "
                              >
                                <MdOutlineRemoveRedEye className="cursor-pointer" />
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <TaskSheetDetail invoice={invoice} setShow={setShow} />
      )}
    </>
  );
};

export default OtherTaskSheets;
